<template>
  <div class="kgk-profile">
    <!--<img alt="Vue logo" src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->

    <UserDetails />

  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
//import RunsList from '@/components/user/RunsList.vue';
import UserDetails from '@/components/user/UserDetails.vue';

export default {
  name: 'Profile',
  components: {
    UserDetails
  }
}
</script>
